import "./AddAutomationCard.scss";
import EntityList from "../../../Components/EntityLogo/EntityList";
import { Label } from "@SeemplicityDev/shared";
import { AutomationUseCase } from "../AddAutomation";
import { snakeCase } from "lodash-es";

type AddAutomationCardProps = Pick<
  AutomationUseCase,
  "icon" | "title" | "description"
> & {
  integrations: {
    displayName: string;
    logo: string;
  }[];
  labels?: string[];
  disabled?: boolean;
  showIntegrations?: boolean;
  onClick: () => void;
};

const AddAutomationCard: React.FC<AddAutomationCardProps> = ({
  icon,
  title,
  description,
  integrations,
  disabled,

  labels,
  showIntegrations,
  onClick,
}) => {
  return (
    <div
      className={`add-automation-card ${disabled ? "is-disabled" : ""}`}
      onClick={onClick}
      data-testid="add-automation-card"
      data-analytics-event="user_click"
      data-analytics-props={`{"name": "add_automation_card", "container": "add_automation_modal", "use_case": "${snakeCase(title)}"}`}
    >
      <div className="card-header">
        <i className={`seem-icon seem-icon-${icon}`} />
        <h3>{title}</h3>
      </div>
      <div className="card-description">{description}</div>
      {showIntegrations && (
        <div className="card-integrations">
          <EntityList list={integrations} />
        </div>
      )}
      {!!labels?.length && (
        <ul className="card-labels">
          {labels.map((label) => (
            <li key={label}>
              <Label text={label} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AddAutomationCard;
